import { render, staticRenderFns } from "./terveyskeskuskoulutusjaksot.vue?vue&type=template&id=0f21a4b7&scoped=true&"
import script from "./terveyskeskuskoulutusjaksot.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjaksot.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjaksot.vue?vue&type=style&index=0&id=0f21a4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f21a4b7",
  null
  
)

export default component.exports